import { apiCall } from "../../services/api-service";

export const getVendorListApi = (params) =>
  apiCall("get", `vendor?${params}`);

export const submitVendorAPI = (body) =>
  apiCall("post", "vendor", body);

export const saveAttachmentApi = (id, body) =>
  apiCall("put", `vendor/add_attachment/${id}`, body);

export const updateVendorAPI = (id, body) =>
  apiCall("put", `vendor/${id}`, body);

export const vendorStatusUpdateApi = (id, body) =>
  apiCall("put", `vendor/status_update/${id}`, body);

export const getVendorEditApi = (id) =>
  apiCall("get", `vendor/edit/${id}`);

export const getVendorDetailsApi = (id) =>
  apiCall("get", `vendor/view/${id}`);
